import {
	Column,
	Entity,
	Index,
	JoinColumn,
	ManyToOne,
	OneToMany,
} from 'typeorm';
import { BaseEntity } from './base.entity';
import { EventOccurrenceSubtaskEntity } from './event-occurrence-subtask.entity';
import { EventEntity } from './event.entity';

@Index('_fk__event__id', ['fkEventId'], {})
@Entity('_event_subtask')
export class EventSubtaskEntity extends BaseEntity {
	@Column('int', { name: '_fk__event__id', nullable: true, unsigned: true })
	public fkEventId!: number | null;

	@Column('varchar', { name: '_name', nullable: true, length: 255 })
	public name!: string | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@OneToMany(
		() => EventOccurrenceSubtaskEntity,
		(eventOccurrenceSubtask) => eventOccurrenceSubtask.fkEventSubtask,
		{},
	)
	public eventOccurrenceSubtasks!: Array<EventOccurrenceSubtaskEntity>;

	@ManyToOne(() => EventEntity, (event) => event.eventSubtasks, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__event__id', referencedColumnName: 'id' }])
	public fkEvent!: EventEntity;
}
